import { createFileRoute } from '@tanstack/react-router';
import { useDashboardContext } from './dashboard-context';
import { IncidentsDashboard } from './sections/Incidents';

export const Route = createFileRoute('/console/$orgId/dashboard/incidents')({
    component: RouteComponent,
});

function RouteComponent() {
    const { dashboards, refetchSignal } = useDashboardContext();

    return (
        <IncidentsDashboard
            key={refetchSignal.incidents}
            loading={dashboards.loading.incidentsDashboard}
            data={dashboards.data.incidentsDashboard}
        />
    );
}
